import { FC } from "react"

import { callIfFunc } from "~/shared/lib/utils"
import { LayoutProps } from "~/shared/ui/layouts/main/types"

import { useMainTemplateProps } from "./useMainTemplateProps"

export function withMainTemplateProps(
	layoutProps: LayoutProps | (() => LayoutProps)
) {
	return (C: FC) => {
		const WithMainTemplateProps = () => {
			"use no memo"

			const dynLayoutProps = callIfFunc(layoutProps)
			useMainTemplateProps(dynLayoutProps)
			return <C />
		}
		WithMainTemplateProps.displayName = C.displayName ?? C.name

		return WithMainTemplateProps
	}
}
